import React, { useState } from "react";
import { useForm } from "react-hook-form";
// import loginImg from '../assets/logo192.png';
import loginImg from "../assets/loginLogo.png";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { useNavigate, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import Cookies from "js-cookie"; // Import js-cookie
import { useEffect } from "react";

const Login = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [togglePassword, setTogglePassword] = useState(false);
  const [loader, setLoader] = useState(false);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const navigate = useNavigate();
  const location = useLocation();
    
  useEffect(() => {
    // Check if a token exists (user is logged in)
    const token = localStorage.getItem("userToken");
  
    if (token) {
      // If the user is navigating back to the login page, log them out
      localStorage.removeItem("userToken");
      axios.defaults.headers.common["Authorization"] = null;
  
      // Prevent forward navigation to the main layout
      navigate("/", { replace: true }); // Replace the current history state to stop forward navigation
  
      // Optionally show a message or alert if needed
      Swal.fire({
        title: "Logged Out",
        text: "You were logged out because you navigated back to the login page.",
        icon: "info",
        confirmButtonText: "Okay",
      });
    }
  }, [navigate]);

  const onSubmit = async (data) => {
    try {
      setLoader(true);
      const response = await axios.post(`${API_BASE_URL}/user/login`, data);

      if (response?.data?.status === "SUCCESS") {
        // Save token in localStorage
        const token = response.data.token;
        localStorage.setItem("userToken", token);

        // Set the token for future requests
        axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

        navigate("/main-layout");

        Swal.fire({
          title: "Login Successful",
          text: "You have successfully logged in.",
          icon: "success",
          confirmButtonText: "Okay",
        });
      } else {
        Swal.fire({
          title: "Login Failed",
          text:
            response?.data?.message ||
            "Something went wrong, please try again.",
          icon: "error",
          confirmButtonText: "Try Again",
        });
      }
    } catch (error) {
      setLoader(false);
      Swal.fire({
        title: "Error",
        text: "An error occurred while logging in. Please try again later.",
        icon: "error",
        confirmButtonText: "Close",
      });
      console.error("Login error:", error);
    } finally {
      setLoader(false);
    }
  };

  return (
    <div className="login_wrapper">
      <div className="login_info_section">
        <div className="icon">
          <img
            src={loginImg}
            width={400}
            height={400}
            className="me-4"
            alt="LOGO"
          />
        </div>
        <div className="content">
          <h6 className="text-dark">
            Powered By{" "}
            <a className="text-dark" href="https://rightserveinfotechsystem.com">
              RIGHT SERVE INFOTECH SYSTEM PVT. LTD.
            </a>
          </h6>
        </div>
      </div>
      <div className="login_form_section">
        <div className="login_form">
          <h2 className="form_title">Login</h2>
          <p className="text">
            Enter your User Id and password to access your account
          </p>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="login_input_wrapper">
              <label htmlFor="userId">User ID</label>
              <div className="login_input">
                <input
                  type="text"
                  placeholder="Enter your User id"
                  className="form-control"
                  id="userId"
                  {...register("userId", { required: "User ID is required" })}
                />
                {errors.userId && (
                  <p className="error">{errors.userId.message}</p>
                )}
              </div>
            </div>
            <div className="login_input_wrapper">
              <label htmlFor="password">Password</label>
              <div className="login_input">
                <input
                  type={togglePassword ? "text" : "password"}
                  placeholder="Enter your password"
                  {...register("password", {
                    required: "Password is required",
                    minLength: {
                      value: 8,
                      message: "Password must be at least 8 characters",
                    },
                    maxLength: {
                      value: 15,
                      message: "Password cannot exceed 15 characters",
                    },
                  })}
                  className="form-control"
                  id="password"
                />
                <FontAwesomeIcon
                  onClick={() => setTogglePassword(!togglePassword)}
                  icon={togglePassword ? faEye : faEyeSlash}
                  className="password_toggle_icon"
                  style={{ cursor: "pointer" }}
                />
                {errors.password && (
                  <p className="validation_message">
                    {errors.password.message}
                  </p>
                )}
              </div>
            </div>
            <button type="submit" className="login_button" disabled={loader}>
              {loader ? "Logging in..." : "Login"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
